// angular import
import { Component, ViewChild, ElementRef } from '@angular/core';
// importing the superclass
import { Module } from './../module.component';
// services import
import { Status } from './../../service/status.service';
import { OrderService } from './order.service';
// models import
import { OrderRequest } from '../../model/order/order_request.model';
import { OrderResponse } from '../../model/order/order_response.model';
import { ModalMaterialDocComponent } from '../modal-material-doc/modal-material-doc.component';

// component definition
@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  providers:
    [
      OrderService
    ]
})
export class OrderComponent extends Module {

  // input values
  order_number =                                      '';
  date_from =                                         '';
  date_to =                                           '';
  draft_date =                                        '';

  order_request =                                     new OrderRequest();
  order_response =                                    new OrderResponse();
  globalExpansion =                                   false;

  searchByDateEnable = false;

  // form object values
  @ViewChild('order_number_form') order_number_form:  ElementRef;
  @ViewChild('date_from_form') date_from_form:        ElementRef;
  @ViewChild('date_to_form') date_to_form:            ElementRef;

  constructor(private orderService: OrderService,
              private status: Status) {

    super();
    this.setBindExposer(this.status.getExposer());
    this.getExposer().getModelsManager().order_request;

    this.setFormEnable(this.getCustomizingService().getBoolean('PURCHASEORDER.LIST.FORM.ENABLE', false));
    this.setAutoSearchEnable(this.getCustomizingService().getBoolean('PURCHASEORDER.LIST.AUTOSEARCH.ENABLE', false));
    this.setSearchByDateEnable(this.getCustomizingService().getBoolean('PURCHASEORDER.LIST.FORM.DATE.ENABLE', false));

    this.setTodayDate();
    this.setDefaultDateFrom();
    this.setDefaultDateTo();
    this.redrawDatesInputField();

    this.requestModelSetUp();
    if (this.getIFRS().getHomeFunctions().FLAG_getDetails) {
      this.order_number = this.getIFRS().getHomeFunctions().getDetails_order_number;
      this.getIFRS().clearAllFunctionsData();
      this.doSearch();
    } else if (this.getIFRS().getHomeFunctions().FLAG_statefulOda) {
      this.order_number = this.getIFRS().getHomeFunctions().getState_order_number;
      this.doSearch();
      this.getIFRS().getHomeFunctions().FLAG_statefulOda = false;
    } else if (this.getAutoSearchEnable()) {
      this.doSearch();
    }
  }

    // set up the request model
    requestModelSetUp() {
        this.getModelsManager().order_request.supplier_code = this.getAccountService().supplierProperties.supplier_code;
        this.getModelsManager().order_request.company_code = this.getAccountService().getUserCompany().code;
        this.getModelsManager().order_request.language = this.getLocale().getPreferredLanguage();
    }

    // send the query to the server
    doSearch() {
        this.getModelsManager().order_request.order_number = this.order_number;
        this.orderService.searchOrders(this.order_number);
        this.showSearchParameters = false;
    }

    // call the print labels remote service
    printLabels(docNum, docPos, matCode) {
        this.orderService.printLabels(docNum, docPos, matCode);
        //this.orderService.printLabels('4500000628', '10', '117537'); // TODO: Cablone one row. TO DELETE
        //this.orderService.printLabels('4500002617', '20', '807598'); // TODO: Cablone more rows. TO DELETE
    }

    // method that handles the change of the supplier code field
    updateOrderNumber() {
        this.order_number = this.order_number_form.nativeElement.value;
        this.getModelsManager().order_request.order_number = this.order_number;
        this.getIFRS().getHomeFunctions().getState_order_number = this.order_number;
    }

    // method that handles the change of the 'from' date
    changeFromDate() {
        this.date_from = this.date_from_form.nativeElement.value;
        if (this.date_from === undefined || this.date_from === '') {
            this.setDefaultDateFrom();
        }
        this.redrawDatesInputField();
    }

    // method that handles the change of the 'to' date
    changeToDate() {
        this.date_to = this.date_to_form.nativeElement.value;
        if (this.date_to === undefined || this.date_to === '') {
            this.setDefaultDateTo();
        }
        this.redrawDatesInputField();
    }

    // set the today date
    setTodayDate() {
        this.getDateTimeManager().setToday();
        this.draft_date = this.getDateTimeManager().ddmmyyyy('-');
    }

    // set the from date (today)
    setDefaultDateFrom() {
        const backwardsDays = -30;
        this.getDateTimeManager().dateCalculation(new Date(), backwardsDays, 'd');
        this.date_from = this.getDateTimeManager().yyyymmdd('-');
    }

    // set the to date
    setDefaultDateTo() {
        const fowardDays = 30;
        this.getDateTimeManager().dateCalculation(new Date(), fowardDays, 'd');
        this.date_to = this.getDateTimeManager().yyyymmdd('-');
    }

    // redraw the date input fields with a valid value
    redrawDatesInputField() {
        if (this.date_from_form !== undefined) { this.date_from_form.nativeElement.value = this.date_from; }
        if (this.date_to_form !== undefined) { this.date_to_form.nativeElement.value = this.date_to; }
    }

    // Returns normalized date
    getNormalDate(value) {
        if (value !== null && value !== undefined) {
            const date = new Date(value);
            this.getDateTimeManager().setDate(date);
            const text = this.getDateTimeManager().ddmmyyyy('/');
            return text;
            } else {
                return '';
            }
    }

    // clear the input values
    clearFormValues() {
        this.order_number = '';
        this.getIFRS().getHomeFunctions().getState_order_number = '';
        this.setDefaultDateFrom();
        this.setDefaultDateTo();
        this.redrawDatesInputField();
        this.requestModelSetUp();
    }

    // return true if service is stil searching
    isServiceSearching() {
        return this.orderService.isSearching();
    }

    // returns the status of the server query
    isResultEmpty() {
        return this.orderService.getOrders().length === 0;
    }

    // returns the request model
    getRequestModel() {
        return this.getModelsManager().order_request;
    }

    // returns the response model
    getOrderServiceResponse() {
        return this.getOrderedList(this.orderService.getOrders(), this.sortType, this.sortReverse);
    }

    // Menage expansion state of table row
    switchGlobalExpansion() {
        this.globalExpansion = !this.globalExpansion;
        for (const element of this.getOrderServiceResponse()) {
            element.expanded = this.globalExpansion;
            for (const subElement of element.positions) {
                subElement.expanded = this.globalExpansion;
            }
        }
    }

    // go to delivery filtered by document number
    getDeliveryByOrder(document_number) {
        // clear the data
        this.getIFRS().clearAllFunctionsData();
        // set the flag and the data
        this.getIFRS().getHomeFunctions().FLAG_getDeliveries = true;
        this.getIFRS().getHomeFunctions().getDeliveries_order_number = document_number;

        this.getIFRS().getHomeFunctions().FLAG_statefulOda = true;
        // switch the page
        this.getIFRS().getSidebar().setMenuItem('delivery');
    }

    // go to material list filtered by material code
    getMaterialByOrder(material_code) {
        // clear the data
        this.getIFRS().clearAllFunctionsData();
        // set the flag and the data
        this.getIFRS().getHomeFunctions().FLAG_getMaterial = true;
        this.getIFRS().getHomeFunctions().getMaterial_material_code = material_code;
        this.getIFRS().getHomeFunctions().FLAG_statefulOda = true;
        // switch the page
        this.getIFRS().getSidebar().setMenuItem('material_list');
    }

    setSearchByDateEnable(value: boolean) {
        this.searchByDateEnable = value;
    }

    getSearchByDateEnable() {
        return this.searchByDateEnable;
    }

/*     // shows the modal of the material's documents
    showDocs(modal: ModalMaterialDocComponent, materialCode, materialDescription) {
        modal.setDocs(materialCode,
                      materialDescription,
                      this.getAccountService().getUserCompany().code,
                      this.getLocale().getPreferredLanguage());
                      modal.show();
    } */
}



// WEBPACK FOOTER //
// ./src/app/components/order/order.component.ts